// IndexedDB avoids localStorage's small quota for reports with thousands of sales.
const memory = new Map();
const openDb = () => new Promise((resolve, reject) => {
  if (typeof indexedDB === 'undefined') return reject(new Error('IndexedDB unavailable'));
  const request = indexedDB.open('valenpos_sales_reports_v4', 1);
  request.onupgradeneeded = () => request.result.createObjectStore('reports');
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});

export async function readSalesReportCache(key) {
  if (memory.has(key)) return memory.get(key);
  try {
    const database = await openDb();
    try {
      return await new Promise((resolve, reject) => {
        const transaction = database.transaction('reports', 'readonly');
        const request = transaction.objectStore('reports').get(key);
        transaction.oncomplete = () => resolve(request.result || null);
        transaction.onerror = () => reject(transaction.error);
        transaction.onabort = () => reject(transaction.error);
      });
    } finally { database.close(); }
  } catch (_) { return memory.get(key) || null; }
}

export async function writeSalesReportCache(key, value) {
  memory.set(key, value);
  try {
    const database = await openDb();
    try {
      await new Promise((resolve, reject) => {
        const transaction = database.transaction('reports', 'readwrite');
        transaction.objectStore('reports').put(value, key);
        transaction.oncomplete = resolve;
        transaction.onerror = () => reject(transaction.error);
        transaction.onabort = () => reject(transaction.error);
      });
    } finally { database.close(); }
    return true;
  } catch (_) { return false; }
}
